/*==========================================================
SCROLL FUNCTION SCRIPT
==========================================================*/
var disableVerticalScroll = true; //disables the functionality to scroll to #pageHeading by passing interior banner
var headerHeight = $("header").height();
var $viewport = $('html, body');

$(function() {
    $(window).scroll(function() {
        disableVerticalScroll = true;
    });

    $viewport.on("scroll mousedown DOMMouseScroll mousewheel keyup", function(e){
        if ( e.which > 0 || e.type === "mousedown" || e.type === "mousewheel"){
             $viewport.stop().unbind('scroll mousedown DOMMouseScroll mousewheel keyup'); // This identifies the scroll as a user action, stops the animation, then unbinds the event straight after (optional)
        }
    });

    // Set Tab focus to appear below sticky header
    $("#uber").on("keyup", "select, input, textarea, button, a, div[tabindex='0']", function(e){
        var code = (e.keyCode ? e.keyCode : e.which);
        if (code == 9 && $("select:focus, input:focus, textarea:focus, button:focus, a:focus, div[tabindex='0']:focus").length) {
            if (e.target.id == "skipContentLink") {  //scroll up to skipContentLink
                $viewport.stop().animate({
                    scrollTop: 0
                }, 500);
            } else if (!$(e.currentTarget).closest("header").length) {
                var ele = $(e.currentTarget).offset().top;
                var eleTop = ele - $(window).scrollTop();
                var newPos = ele - headerHeight;

                if (headerHeight > eleTop) {
                    $viewport.stop().animate({
                        scrollTop: newPos
                    }, 500);
                }
            }
        }
    });

    if (Modernizr.mq("(min-width: 1199px)")) {
        $('#uber').css('padding-top', $("header").height());
    }else {
        $('#uber').css('padding-top',  0);
    }

    $(window).on('resize',function(){
        if (Modernizr.mq("(min-width: 1199px)")) {
            $('#uber').css('padding-top',  $("header").height());
        } else {
            $('#uber').css('padding-top',  0);
        }
    })
});


$(window).load(function() {

    // Ignore if page is using ScrollTo functionality from URL (facility module)
    // OR - if emergency carousel exists
    var pageURL = window.location.href;
    if (pageURL.indexOf("ScrollTo=") == -1 && !$("#emergencyCarousel").is("*")) {
        //Scroll to Anchor links on page load when anchor hash is part of URL
        if (window.location.hash) {
            var hash = decodeURI(window.location.hash.substring(1)).replace(/\s|[`~!@#$%^&*()|+\=?;:'",.<>\{\}\[\]\\\/]/gi, ''),
                hashIsEl = true;
            if (hash != '') {
                if ($('[name=' + hash + ']').length > 0) {
                    hash = $('[name=' + hash + ']');
                } else if ($('#' + hash).length > 0) {
                    hash = $('#' + hash);
                } else {
                    hashIsEl = false;
                }
                if (hashIsEl) {
                    var offsetTop = hash.offset().top - headerHeight;
                    if ($(hash).parents('.Accordion').length) {
                        var $accTrigger = $(hash).closest('.Accordion').find('.AccordionTrigger');
                        $accTrigger.trigger("click");
                        offsetTop = $accTrigger.offset().top - headerHeight;
                    }
                    $viewport.stop().animate({
                        scrollTop: offsetTop
                    }, 1000);
                    $(hash).focus();
                }
            }
        } else if (disableVerticalScroll != true && $('#intBg').length && !$('.hideBanner').length && !$('.blogFeed').length) {
            // Scroll to #pageHeading and by pass interior banner if loading a page from the same/current vertical
            var offsetTop = $('#pageHeading').offset().top - 0;

            if ($(this).scrollTop() < offsetTop) { // if scroll is less than the scroll to position.
                var loc = window.location.pathname;
                var referrer = document.referrer.replace(/^.*\/\/[^\/]+/, '');

                var currentDir = loc.substring(0, loc.lastIndexOf('/'));
                var referrerDir = referrer.substring(0, referrer.lastIndexOf('/'));


                if ($('#uber').hasClass('interior')) {
                    if (referrerDir.toLowerCase() == currentDir.toLowerCase()) {
                        $viewport.stop().animate({
                            scrollTop: offsetTop
                        }, 1000);
                    }
                }
            }
        }

    }
});